import { createPaymentTokenRequest } from "../../services/paymentService";

export function DebugToolPaymentTokenSnippet() {
    
    function onShow() {
        const sample: NewCardDetails = {
            number: '<card number>',
            expMonth: '<expiry month (01 to 12)>',
            expYear: '<expiry year (20XX)>',
            cvc: '<cvc>',
            isDefault: true
        }
        const req = createPaymentTokenRequest(sample);
        return JSON.stringify(req, null, 1);
    }
    return (
        <div className="snippet-container">
            <pre>
                { onShow() }
            </pre>
        </div>
    )
}